import apiClient from './apiClient';
import { ENDPOINTS } from '../constants/api';

/**
 * AboutUs Service
 * Wraps backend endpoints for fetching, adding, updating, and deleting AboutUs items.
 */

/**
 * Fetches all AboutUs items
 * @returns {Promise<Array>} List of items
 */
export async function getAllAboutUs() {
  const { data: response } = await apiClient.get(ENDPOINTS.aboutUs.all);
  return response?.data || [];
}

/**
 * Fetches a single AboutUs item by ID
 * @param {number} id
 * @returns {Promise<object>}
 */
export async function getAboutUs(id) {
  const { data: response } = await apiClient.get(ENDPOINTS.aboutUs.get(id));
  return response?.data;
}

/**
 * Creates a new AboutUs card
 * @param {{ title: string, text: string, mediaUrls: string[] }} dto
 * @returns {Promise<object>}
 */
export async function addAboutUs(dto) {
  const { data: response } = await apiClient.post(ENDPOINTS.aboutUs.add, dto);
  return response;
}

/**
 * Updates an existing AboutUs card
 * @param {number} id
 * @param {{ title: string, text: string, mediaUrls: string[] }} dto
 * @returns {Promise<object>}
 */
export async function updateAboutUs(id, dto) {
  const { data: response } = await apiClient.put(ENDPOINTS.aboutUs.update(id), dto);
  return response;
}

/**
 * Deletes an AboutUs card by ID
 * @param {number} id
 * @returns {Promise<object>}
 */
export async function deleteAboutUs(id) {
  const { data: response } = await apiClient.delete(ENDPOINTS.aboutUs.delete(id));
  return response;
}
